export default __webpack_public_path__ + "static/media/54.6073c677.png";